class SalutBlogList extends HTMLElement {
  connectedCallback() {
    this.groupsPerPage = parseInt(this.dataset.groupsPerPage, 10) || 3;
    this.articlesPerGroup = parseInt(this.dataset.articlesPerGroup, 10) || 3;
    this.groups = Array.from(this.querySelectorAll('[data-group]'));
    this.pagination = this.querySelector('[data-pagination]');
    this.pageList = this.querySelector('[data-page-list]');
    this.prev = this.querySelector('[data-page-prev]');
    this.next = this.querySelector('[data-page-next]');
    this.search = this.querySelector('[data-search]');
    this.empty = this.querySelector('[data-empty]');
    this.form = this.querySelector('form');
    this.page = 1;
    this.query = '';

    this.groups.forEach((group) => this.bindToggle(group));

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.search.blur();
      });
    }

    if (this.search) {
      this.search.addEventListener('input', () => {
        this.query = this.search.value.trim().toLowerCase();
        this.page = 1;
        this.render();
      });
    }

    if (this.prev) {
      this.prev.addEventListener('click', () => this.goTo(this.page - 1));
    }

    if (this.next) {
      this.next.addEventListener('click', () => this.goTo(this.page + 1));
    }

    this.render();
  }

  bindToggle(group) {
    const toggle = group.querySelector('[data-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      const label = toggle.querySelector('[data-toggle-text]');
      if (label) {
        label.textContent = expanded ? toggle.dataset.labelAll : toggle.dataset.labelLess;
      }
      this.render();
    });
  }

  matchingCells(group) {
    const cells = Array.from(group.querySelectorAll('[data-cell]'));
    if (!this.query) return cells;
    return cells.filter((cell) => (cell.dataset.title || '').indexOf(this.query) !== -1);
  }

  render() {
    const visibleGroups = [];

    this.groups.forEach((group) => {
      const matching = this.matchingCells(group);
      const cells = Array.from(group.querySelectorAll('[data-cell]'));
      const toggle = group.querySelector('[data-toggle]');
      const expanded = toggle ? toggle.getAttribute('aria-expanded') === 'true' : true;
      const limit = this.query || expanded ? matching.length : this.articlesPerGroup;

      cells.forEach((cell) => {
        const index = matching.indexOf(cell);
        const show = index !== -1 && index < limit;
        cell.classList.toggle('salut-blog__cell--hidden', !show);
      });

      if (toggle) {
        toggle.hidden = Boolean(this.query) || matching.length <= this.articlesPerGroup;
      }

      if (matching.length > 0) visibleGroups.push(group);
    });

    const pages = this.query ? 1 : Math.max(1, Math.ceil(visibleGroups.length / this.groupsPerPage));
    if (this.page > pages) this.page = pages;

    const start = this.query ? 0 : (this.page - 1) * this.groupsPerPage;
    const end = this.query ? visibleGroups.length : start + this.groupsPerPage;

    this.groups.forEach((group) => {
      const index = visibleGroups.indexOf(group);
      const show = index !== -1 && index >= start && index < end;
      group.classList.toggle('salut-blog__group--hidden', !show);
    });

    if (this.empty) this.empty.hidden = visibleGroups.length > 0;

    this.renderPagination(pages);
  }

  renderPagination(pages) {
    if (!this.pagination) return;

    this.pagination.hidden = pages <= 1;
    if (pages <= 1) return;

    this.prev.disabled = this.page === 1;
    this.next.disabled = this.page === pages;

    const numbers = [];
    for (let i = 1; i <= pages; i += 1) {
      if (i === 1 || i === pages || Math.abs(i - this.page) <= 1) {
        numbers.push(i);
      } else if (numbers[numbers.length - 1] !== '…') {
        numbers.push('…');
      }
    }

    this.pageList.textContent = '';
    numbers.forEach((value) => {
      if (value === '…') {
        const gap = document.createElement('span');
        gap.className = 'salut-blog__page-item salut-blog__page-item--gap';
        gap.textContent = '…';
        this.pageList.appendChild(gap);
        return;
      }

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'salut-blog__page-item';
      if (value === this.page) {
        button.classList.add('salut-blog__page-item--current');
        button.setAttribute('aria-current', 'page');
      }
      button.textContent = String(value);
      button.addEventListener('click', () => this.goTo(value));
      this.pageList.appendChild(button);
    });
  }

  goTo(page) {
    this.page = page;
    this.render();
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

if (!customElements.get('salut-blog-list')) {
  customElements.define('salut-blog-list', SalutBlogList);
}
